module.exports = __webpack_public_path__ + "img/szh2.5bef02f1.jpg";